$(window).scroll(function () {
    if($(window).scrollTop() > 50) {
        $('.header').addClass('fixed');
    } else {
        $('.header').removeClass('fixed');
    }
});

$(document).on('click', '.btn-trigger, .header-bg', function() {
    $(this).toggleClass('active')
    $("body, .header-nav").toggleClass('open')
    $(".header-bg").fadeToggle()
})

// FV video DOM後挿入
window.addEventListener('load', function () {
  const wrap = document.getElementById('fvVideo');
  if (!wrap) return;

  // すでに video が入っていたら何もしない（二重防止）
  if (wrap.querySelector('video')) return;

  const isSP = window.matchMedia('(max-width: 768px)').matches;
  const src = isSP ? wrap.dataset.videoSp : wrap.dataset.videoPc;
  if (!src) return;

  const video = document.createElement('video');
  video.className = 'fv-video';
  video.autoplay = true;
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = 'none';
  video.setAttribute('aria-hidden', 'true');

  const source = document.createElement('source');
  source.src = src;
  source.type = 'video/webm';
  video.appendChild(source);

  // posterの上に重ねる（消さない）
  wrap.appendChild(video);

  // 動画が再生可能になったら poster をフェードアウト
  video.addEventListener('loadeddata', function () {
    const poster = wrap.querySelector('.fv-video-poster');
    if (poster) {
      poster.style.transition = 'opacity .4s ease';
      poster.style.opacity = '0';
    }
  });
});

// 下層video DOM後挿入
document.addEventListener('DOMContentLoaded', function () {
  const lazyVideos = document.querySelectorAll('.lazy-video');
  if (!lazyVideos.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const wrap = entry.target;

      // 二重生成防止
      if (wrap.querySelector('video')) {
        obs.unobserve(wrap);
        return;
      }

      const src = wrap.dataset.videoSrc;
      if (!src) return;

      const video = document.createElement('video');
      video.className = 'commitment-video';
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('aria-hidden', 'true');

      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/webm';
      video.appendChild(source);

      // posterの上に追加（消さない）
      wrap.appendChild(video);

      // 読み込めたら poster をフェードアウト
      video.addEventListener('loadeddata', () => {
        const poster = wrap.querySelector('.lazy-video-poster');
        if (poster) {
          poster.style.transition = 'opacity .3s ease';
          poster.style.opacity = '0';
        }
      });

      obs.unobserve(wrap);
    });
  }, {
    rootMargin: '200px 0px',
    threshold: 0
  });

  lazyVideos.forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", function() {
    swiper = new Swiper(".voice-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 25
            }
        },
    });
});

$(window).scroll(function () {
    if($(window).scrollTop() > 250) {
        $(".floating").fadeIn()
    } else {
        $(".floating").fadeOut()
    }
});

$(document).on('click', '.floating-close', function() {
    $(".floating").remove()
})

window.setTimeout(function() {
    if($(".globo-form-control").length) {
        $(".globo-form-control").each(function() {
            if($(this).find('.globo-label').find('.text-danger').length) {
                console.log(true)
                $(this).addClass('required')
            }
        });
    }
}, 500);

/**
 * Shopjar referral coupon auto-apply
 * - sj_rcp_discount_code_input_v2 の value 変化を監視
 * - 値が入ったら /cart/update.js で割引適用
 */
(function () {
  const INPUT_SELECTOR = '.sj_rcp_discount_code_input_v2';
  const APPLY_KEY = 'sj_coupon_applied';

  let lastValue = null;
  let applied = false;

  if (sessionStorage.getItem(APPLY_KEY)) {
    applied = true;
  }

  async function applyDiscount(code) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
      console.log('[Shopjar] discount applied:', code);
    } catch (e) {
      console.warn('[Shopjar] apply discount failed', e);
    }
  }

  async function checkAndApply() {
    if (applied) return;

    const input = document.querySelector(INPUT_SELECTOR);
    if (!input) return;

    const value = input.value;
    if (!value || value === lastValue) return;

    lastValue = value;

    applied = true;
    sessionStorage.setItem(APPLY_KEY, '1');

    console.log('[Shopjar] coupon detected:', value);
    applyDiscount(value);
  }

  document.addEventListener('DOMContentLoaded', function () {
    checkAndApply();
  });

  const observer = new MutationObserver(function () {
    checkAndApply();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const isSP = window.matchMedia('(max-width: 767px)').matches;
  const root = document.getElementById('voiceInstagram');
  if (!root) return;

  // PCでは非表示
  if (!isSP) {
    root.remove();
    return;
  }

  root.innerHTML = `
    <div class="voice-instagram-placeholder">
      <p>イベントで試着した、パパママの感想</p>
      <button type="button">Instagramの投稿を表示</button>
    </div>
  `;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      // 本体DOMを挿入
      root.innerHTML = `
        <div class="voice-instagram-label">
          <p>イベントで試着した、パパママの感想</p>
        </div>

        <blockquote class="instagram-media"
          data-instgrm-permalink="https://www.instagram.com/reel/DRwnR4bj_Zh/?utm_source=ig_embed&amp;utm_campaign=loading"
          data-instgrm-version="14"
          style="background:#FFF;border:0;border-radius:3px;box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15);margin:1px;max-width:540px;min-width:326px;padding:0;width:100%;">
        </blockquote>
      `;

      // embed.js をこのタイミングでロード
      if (!document.querySelector('script[src*="instagram.com/embed.js"]')) {
        const s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.instagram.com/embed.js';
        document.body.appendChild(s);
      } else if (window.instgrm?.Embeds?.process) {
        window.instgrm.Embeds.process();
      }

      obs.unobserve(root);
    });
  }, {
    rootMargin: '300px 0px', // 見える少し前
    threshold: 0
  });

  observer.observe(root);
});